import type {
  IActivateProspectInput,
  ICreateProspectContact,
  ICreateProspectInput,
  ICreateProspectResponse,
  IGetProspectsParams,
  IProspect,
  IProspectsResponse,
  IUpdateProspectContact,
  IUpdateProspectInput
} from '../../../interfaces/prospects';
import {
  ACTIVATE_PROSPECT_MOCK_RESPONSE,
  CREATE_PROSPECT_CONTACT_MOCK_RESPONSE,
  CREATE_PROSPECT_MOCK_RESPONSE,
  GET_PROSPECTS_MOCK_RESPONSE,
  UPDATE_PROSPECT_CONTACT_MOCK_RESPONSE,
  UPDATE_PROSPECT_MOCK_RESPONSE
} from '../../../mocks/prospects';
import { HttpService } from '../../http/httpService';

export class Prospects {
  static async getProspects(brokerId: string, params: IGetProspectsParams = {}): Promise<IProspect[]> {
    const response = await HttpService.get<IProspectsResponse>(
      `brokers/${brokerId}/prospects`,
      { params },
      GET_PROSPECTS_MOCK_RESPONSE()
    );
    return response.data.prospects;
  }

  static async createProspect(brokerId: string, body: ICreateProspectInput): Promise<ICreateProspectResponse> {
    const response = await HttpService.post<ICreateProspectResponse>(
      `brokers/${brokerId}/prospects`,
      body,
      {},
      CREATE_PROSPECT_MOCK_RESPONSE()
    );
    return response.data;
  }

  static async updateProspect(brokerId: string, prospectId: number, body: IUpdateProspectInput): Promise<void> {
    await HttpService.patch<void>(
      `brokers/${brokerId}/prospects/${prospectId}`,
      body,
      {},
      UPDATE_PROSPECT_MOCK_RESPONSE()
    );
  }

  static async createProspectContact(
    brokerId: string,
    prospectId: number,
    body: ICreateProspectContact
  ): Promise<ICreateProspectResponse> {
    const response = await HttpService.post<ICreateProspectResponse>(
      `brokers/${brokerId}/prospects/${prospectId}/contacts`,
      body,
      {},
      CREATE_PROSPECT_CONTACT_MOCK_RESPONSE()
    );
    return response.data;
  }

  static async updateProspectContact(
    brokerId: string,
    prospectId: number,
    contactId: number,
    body: IUpdateProspectContact
  ): Promise<void> {
    await HttpService.patch<void>(
      `brokers/${brokerId}/prospects/${prospectId}/contacts/${contactId}`,
      body,
      {},
      UPDATE_PROSPECT_CONTACT_MOCK_RESPONSE()
    );
  }

  static async activateProspect(
    brokerId: string,
    prospectId: number,
    activationDate: string,
    quoteIds: number[]
  ): Promise<void> {
    const body: IActivateProspectInput = { activationDate, quoteIds };
    await HttpService.post<void>(
      `brokers/${brokerId}/prospects/${prospectId}/activate`,
      body,
      {},
      ACTIVATE_PROSPECT_MOCK_RESPONSE()
    );
  }
}

export default Prospects;
